import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=af71cd20&scoped=true"
var script = {}
import style0 from "./Hero.vue?vue&type=style&index=0&id=af71cd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af71cd20",
  null
  
)

export default component.exports